import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
import { BaseIcon } from "../base-icon";
export var SearchIcon = function(_param) /*#__PURE__*/ {
    var color = _param.color, _size = _param.size, size = _size === void 0 ? 16 : _size, props = _object_without_properties(_param, [
        "color",
        "size"
    ]);
    return _jsx(BaseIcon, _object_spread_props(_object_spread({}, props), {
        color: color,
        height: size,
        width: size,
        children: size === 16 ? /*#__PURE__*/ _jsx("path", {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "M9.68 10.74a6 6 0 1 1 1.06-1.06l4.79 4.79a.75.75 0 1 1-1.06 1.06l-4.79-4.79ZM10.4 6a4.4 4.4 0 1 1-8.8 0 4.4 4.4 0 0 1 8.8 0Z",
            clipRule: "evenodd"
        }) : /*#__PURE__*/ _jsx("path", {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "M15.666 16.727A9.462 9.462 0 0 1 9.5 19 9.5 9.5 0 1 1 19 9.5a9.462 9.462 0 0 1-2.273 6.166l6.803 6.804a.75.75 0 1 1-1.06 1.06l-6.804-6.803ZM17.5 9.5a8 8 0 1 1-16 0 8 8 0 0 1 16 0Z",
            clipRule: "evenodd"
        })
    }));
};
